export enum AccountType {
  scientist,
  industry,
  university,
  labTech,
  medLabTech,
  ssoAuthedUser,
  fakeUser,
}
